import { render, staticRenderFns } from "./FavoriteDesignersPageContainer.vue?vue&type=template&id=7759bd89&"
import script from "./FavoriteDesignersPageContainer.vue?vue&type=script&lang=js&"
export * from "./FavoriteDesignersPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports